import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

export abstract class ButtonBlockBackgroundColorBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_BUTTON].BUTTON_BLOCK_BACKGROUND_COLOR;
  }
}
